import { get, mapKeys } from 'lodash';
import { ABServiceClient } from '@zocdoc/ab';

import { ACTION_TYPES } from '../constants';
import {
    FULLSTORY_WHITELIST,
    FULLSTORY_EXPERIMENT_KEY_PREFIX,
    FULLSTORY_SCRIPT,
} from './constants';
import { pageName as homePageName } from '../Home/constants';
import { getABParameters } from '../config/ab/selector';

const AB_HOST = process.env.AWS_API_HOST || '';

export const abClient = new ABServiceClient({
    fetch,
    basePath: AB_HOST,
});

/**
 * Format the experiment IDs for Fullstory
 * The field names must be: alphanumeric, camelCase, and ending in `_${type}` ('_str' in our case)
 * Reference: http://help.fullstory.com/develop-js/setuservars
 */
export function formatForFullstory(fieldName) {
    const words = fieldName.split(/[\W_]+/g).filter(s => s);

    // convert to camelcase
    fieldName = words.map((str, index) => {
        str = str.toLowerCase();
        return index === 0 ? str : str[0].toUpperCase() + str.slice(1);
    }).join('');

    // append suffix
    return `${fieldName}_str`;
}

/**
 *  Function to load fullstory depending on AB flag
 */
export const maybeLoadFullstory = (store, pageName) => {
    const cleanedPageName = pageName.replace(/\s/g, '_');
    const abParameters = getABParameters(store.getState());
    const experimentId = `${FULLSTORY_EXPERIMENT_KEY_PREFIX}-${cleanedPageName}`;
    const fullstoryAbExperimentIsEnabled = abParameters ? abParameters[experimentId] === 'true' : false;
    const fullstoryAllowedForThisPage = FULLSTORY_WHITELIST.has(pageName);

    if (!fullstoryAbExperimentIsEnabled || !fullstoryAllowedForThisPage) {
        return;
    }

    const fullstoryScript = document.createElement('script');
    fullstoryScript.defer = true;
    fullstoryScript.innerHTML = FULLSTORY_SCRIPT;
    document.head.appendChild(fullstoryScript);

    // if user is in this code path on homepage, ab test has returned 1z homepage
    abParameters.on_homepage = pageName === homePageName ? 'true' : 'false';

    const formattedAbParameters = mapKeys(abParameters, (value, key) => formatForFullstory(key));

    // The Fullstory script adds a global FS variable.
    // Because the script was defined via .innerHtml, it is executed synchronously.
    FS.setUserVars(formattedAbParameters); // eslint-disable-line no-undef
};

const fullstoryMiddleware = store => next => action => {
    if (action.type === ACTION_TYPES.PAGE_LOAD) {
        maybeLoadFullstory(store, get(action, 'pageName', ''));
    }

    return next(action);
};

export {
    fullstoryMiddleware,
    fullstoryMiddleware as default,
};
